<template>
  <div>
    <el-page-header
      @back="goBack()"
      title=""
      v-bind:content="title"
      class="page_header"
    >
    </el-page-header>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.query.title_name == undefined) {
      this.title = this.$route.name
    } else {
      this.title = this.$route.query.title_name
    }
  },
  name: 'FirstHeader',
  data() {
    return {
      title: '',
    }
  },
  methods: {
    goBack(e) {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
/* 取消原有样式 */
/deep/ .el-icon-back:before {
  content: '\e6de';
}
/deep/ .el-page-header__left .el-icon-back {
  font-size: 1.9375rem !important;
  padding-top: 3.9375rem;
  padding-left: 2.1875rem;
  color: #333333;
}
.imh {
  width: 0.841875rem;
  height: 1.5925rem;
}
.page_header {
  width: 46.875rem;
  height: 5.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
/deep/ .el-page-header__content {
  width: 40rem;
  text-align: center;
  align-items: center;
  color: #333333;
  font-size: 1.75rem;
  margin-top: auto;
  margin-bottom: auto;
}
/deep/ .el-page-header__left {
  width: 0.85625rem;
  height: 1.5925rem;
}
/deep/.el-page-header__left::after {
  background: #ffffff;
}
</style>
